/**
 * Code generated by scripts/gen-phosphor-icons.mjs. DO NOT EDIT.
 * Phosphor Icons 2.1.1, MIT License. See NOTICE.md.
 */

import {createSinglePathSVG} from './TEMPLATE'

// Phosphor: arrow-elbow-right-down (regular)
export const ArrowCornerDownRight_Stroke2_Corner2_Rounded = createSinglePathSVG(
  {
    viewBox: '0 0 256 256',
    path: 'M229.66,165.66l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L168,188.69V72H32a8,8,0,0,1,0-16H176a8,8,0,0,1,8,8V188.69l34.34-34.35a8,8,0,0,1,11.32,11.32Z',
  },
)

// Phosphor: arrow-elbow-right-down (regular)
export const ArrowCornerDownRight_Stroke2_Corner3_Rounded = createSinglePathSVG(
  {
    viewBox: '0 0 256 256',
    path: 'M229.66,165.66l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L168,188.69V72H32a8,8,0,0,1,0-16H176a8,8,0,0,1,8,8V188.69l34.34-34.35a8,8,0,0,1,11.32,11.32Z',
  },
)
